import type { AlarmAction, AlarmException } from "@src/services/api/types";

export type ExceptionParam = {
  reason: string;
  action: AlarmAction;
  period: AlarmException["period"];
};

// Lightweight ref to pass updated exception data back from the details screen
export const pendingExceptionDetailUpdate: { current: ExceptionParam | null } = { current: null };
